import { ProposalStatus } from "../../components/ProposalTable/proposalStatusRenderer";
export interface IConsignadoProposalsList {
  pagina_anterior: number | null;
  pagina_atual: number;
  proxima_pagina: number | null;
  tamanho_pagina: number;
  total: number;
  total_paginas: number;
  data: IConsignadoProposal[];

}

export interface IConsignadoProposal {
  cpf: string;
  cep?: string;
  agencia?: string
  conta?: string
  digito_conta?: string
  digito_agencia?: string
  tipo_conta?: number
  telefone?: string
  numero_banco?: string
  nome_cliente: string;
  nome_fundo?: string;
  data_proposta: string;
  data_formalizacao: string | null;
  data_pagamento: string | null;
  data_atualizacao?: string | null;
  custom_status: ProposalConsignadoCustomStatus | string;
  status: string;
  valor_liberado: number | null;
  produto_nome: string;
  id_proposta: string;
  id_vendedor: string;
  nome_vendedor: string;
  id_pessoa_natural: string;
  nome_corban: string;
  nome_promotora: string;
  origem?: string;
  nome_campanha?: string | null;
  unico_score?: string
  frente_documento?: string
  verso_documento?: string
  evidencia?: string
  short_hash: string
  // Dados do vínculo/margem, presentes só quando a lista é pedida com
  // `incluir=banco_detalhe` (usados na tela de Análise Banco). Vêm prontos do
  // back: data_admissao já formatada e idade_cnpj_meses já calculada (mesma
  // base da análise de crédito: empregador da margem).
  data_admissao?: string | null;
  idade_cnpj_meses?: number | null;
  codigo_cnae?: number | null;
  setor_cnae?: string | null;
  codigo_cbo?: number | null;
  descricao_cbo?: string | null;
  base_calculo_margem?: number | null;
  salario?: number | null;
}

export interface IConsignadoProposalDetail {
  id_apolice?: string;
  id_externo_seguradora?: string;
  documento_formalizacao?: string | null;
  documento_formalizacao_verso?: string | null;
  foto_formalizacao?: string | null;
  id_proposta?: string;
  id_externo: string;
  status_proposta: ProposalStatus;
  numero_ccb?: string;
  short_hash: string;
  unico_data_id?: string;
  origem?: string;
  contrato_url?: string | null;
  contrato_assinado_url?: string | null;
  seguro_contrato_url?: string | null;
  seguro_contrato_assinado_url?: string | null;
  comprovante_averbacao_url?: string;
  comprovante_cancelamento_url?: string;
  contrato_split_url?: string | null;
  contrato_assinado_split_url?: string | null;
  recibo_pagamento_url?: string | null;
  custom_status?: ProposalConsignadoCustomStatus | string;
  status_unico?: string | null;
  cliente_nome: string;
  cliente_cpf: string;
  numero_parcelas?: string | null;
  valor_liberado: number;
  valor_descontado?: number | null;
  taxa_mensal: number;
  tipo_conta?: string;
  agencia: string;
  digito_agencia?: string | null;
  conta: string;
  digito_conta?: string | null;
  numero_banco: string;
  data_proposta: string;
  data_formalizacao?: string | null;
  data_pagamento?: string | null;
  valor_seguro?: number;
  formalizacao_url?: string;
  localizacao?: string
  telefone?: string;
  iof?: number;
  taxa_anual?: number;
  cet_anual?: number;
  cet_mensal?: number;
  valor_parcela?: number;
}

export interface ProposalConsignadoCustomStatus {
  confirmacao?: {
    criacao_seguranca_identidade: StatusItem;
    dados_tomador: StatusItem;
  };
  formalizacao?: {
    aceite_tomador: StatusItem;
    seguranca_identidade: StatusItem;
    contratacao_seguro: StatusItem;
    apolice_entregue: StatusItem;
    contratacao_banco: StatusItem;
    ccb_entregue: StatusItem;
    assinatura_contrato: StatusItem;
    assinatura_proposta_seguro: StatusItem;
    averbacao_finalizada: StatusItem;
    liberacao_dataprev: StatusItem;
  };
  pagamento?: {
    processando_pagamento: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    pago: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cedida_fundo: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  },
  cancelamento: {
    bloqueio_saldo_negado: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelado_usuario: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    reprovado_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelamento_outros: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelado_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
    cancelado_seguro: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelado_sistema: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }

  },
  acoes?: {
    refazer_seguranca_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    refazer_contratacao_seguro: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    },
    refazer_contratacao_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    },
    refazer_assinatura_contrato: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    },
    analise_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    },
    corrigir_dados_bancarios: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    }
  },
  averbacao: {
    corrigir_taxas_juros: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    vinculo_inelegivel_trabalhador: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  },
  // Snapshot da oferta e do seguro escolhidos — não são grupos de log. A
  // consulta lê os valores financeiros daqui em vez do financial_info/insurance_info.
  oferta_escolhida?: OfertaEscolhidaCustomStatus;
  seguro_escolhido?: SeguroEscolhidoCustomStatus;
}

// Espelha a financialInfo escolhida (mesmos nomes do back). Taxas/CET em
// percentual (ex.: 6 = 6% a.m.); `loanAmount` é o total descontado (parcela × nº).
export interface OfertaEscolhidaCustomStatus {
  releasedAmount?: number | null;
  installmentValue?: number | null;
  numberOfInstallments?: number | null;
  loanAmount?: number | null;
  monthlyRate?: number | null;
  annualRate?: number | null;
  monthlyCETAmount?: number | null;
  annualCETAmount?: number | null;
  iofAmount?: number | null;
  insuranceValue?: number | null;
}

// Espelha a insuranceInfo escolhida. `installment` é o NÚMERO de parcelas.
export interface SeguroEscolhidoCustomStatus {
  chosenInsuranceInfoId?: string | null;
  insuranceAmount?: number | null;
  loanAmount?: number | null;
  installment?: number | null;
  iof?: number | null;
  policyId?: string | null;
  simulationId?: string | null;
  idCoverageProduct?: string | null;
  insuranceCompanyId?: string | null;
}

interface StatusItem {
  status: "sucesso" | "erro" | "aguardando";
  mensagem: string;
}

export enum ProposalCustomStatusItenStatus {
  AGUARDANDO = "aguardando",
  ERRO = "erro",
  SUCESSO = "sucesso",
  PENDING = "aguardando",
}

export type ProposalCustomStatus = {
  confirmacao: {
    criacao_proposta_bancarizadora: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    criacao_processo_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    analise_proposta_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
  };
  acoes: {
    correcao_dados_pessoais_bancarios: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    corrigir_dados_bancarios: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    correcao_dados_proposta_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    tentar_novamente_proposta_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    criar_processo_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    refazer_processo_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    analise_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    analisar_proposta_banco_valor: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    };
    analisar_proposta_banco_documento: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    };
    analisar_proposta_banco_multiplas: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    };
    analisar_proposta_banco_biometria: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string
    };
    erro_simulacao_nao_encontrada: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    tentar_novamente_additional_data_zipdin: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    aguardar_validade_leilao?: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
  };
  formalizacao: {
    ccb_entregue: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    bloqueio_saldo: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    seguranca_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    assinatura_contrato: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    envio_contrato_assinado: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
  };
  pagamento: {
    processando_pagamento: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    pago: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    };
    cedida_fundo: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
    comprovante_pagamento: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
  };
  cancelamento: {
    bloqueio_saldo_negado: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelado_usuario: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    reprovado_seg_identidade: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelamento_outros: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelado_banco: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }
    cancelado_seguro: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    },
    cancelado_sistema: {
      status: ProposalCustomStatusItenStatus;
      mensagem?: string;
    }

  };
  autocontratacao?: {
    cpf?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    simulacao?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    whatsapp?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    dados_pessoais?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    endereco?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    dados_bancarios?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    analise?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    proposta?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    revisao?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    consentimento?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    localizacao?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    aceite_contratacao?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
    biometria?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
  };
  leilao?: {
    validade_leilao?: { status: ProposalCustomStatusItenStatus; mensagem?: string };
  };
};

export const AccountTypeLabelsConsignado = {
  1: "Conta Corrente",
  2: "Poupança",
};

export interface BankDetailsConsignado {
  account: string;
  accountDigit: string;
  agency: string;
  agencyDigit: string;
  bankCode: string;
  accountType: number;
}

export interface BankDetailsConsignadoRequest {
  agencia: string;
  digito_agencia: string;
  numero_conta: string;
  digito_conta: string;
  tipo_conta: number;
  banco_codigo: string;
}

export interface NotificationReportResponse {
  id_proposta: string;
  tipo_evento: string;
  cliente: {
    nome: string | null;
    cpf: string | null;
    canais_disparo: {
      email: {
        endereco: string | null;
        enviado: boolean;
        data_envio: string | Date | null;
        erro: string | null;
      };
      chatbot: {
        telefone: string | null;
        enviado: boolean;
        data_envio: string | Date | null;
        erro: string | null;
      };
    };
  };
  empresa: {
    nome: string | null;
    cnpj: string | null;
    canais_disparo: {
      email: {
        endereco: string | null;
        enviado: boolean;
        data_envio: string | Date | null;
        erro: string | null;
      };
      chatbot: {
        telefone: string | null;
        enviado: boolean;
        data_envio: string | Date | null;
        erro: string | null;
      };
    };
  };
  data_criacao: string | Date;
  data_atualizacao: string | Date;
}
